// extracted by mini-css-extract-plugin
module.exports = {"menu_bg_color":"#545c64","menu_text_color":"#fff","node_scale":".6"};